module.exports = __webpack_public_path__ + "media/images/athletes/3553-5bdcdd237f7f7135fde0daa5d524d273.png";